import { createSelector } from 'reselect';

export const selectFormGeneration = createSelector(({ formGeneration }) => formGeneration, result => result);

export const selectOperationType = createSelector(({ formGeneration }) => formGeneration.operationType, result => result);

export const selectDefinitionType = createSelector(({ formGeneration }) => formGeneration.definitionType, result => result);

export const selectListingType = createSelector(({ formGeneration }) => formGeneration.listingType, result => result);

export const selectDefaultValues = createSelector(({ formGeneration }) => formGeneration.defaultValues, result => result);

export const selectListingSelected = createSelector(({ listing }) => listing.selectedListing, result => result);

export const selectAgentSelected = createSelector(({ agent }) => agent.agentSelected, result => result);

export const selectOfficeSelected = createSelector(({ office }) => office.currentOffice, result => result);

/*
 Select Listings's form data taking default values into account:
  * on Create : pre-populate the field with the default value;
  * on Full Edit : Listing data takes priority over default values, even if Listing has null data for the field;
  * on Task Edits (chgMajor, chgSold etc) : non-null fields in listing data override defaults, but default values override null properties in listing data.
*/
export const selectListingFormData = createSelector(
  selectOperationType,
  selectDefinitionType,
  selectListingType,
  selectDefaultValues,
  selectListingSelected,
  (operationType, definitionType, listingType, defaultValues, selectedListing) => {
    if (definitionType !== 'listings') return null;
    if (operationType === 'edit' && !selectedListing) return null;

    const formData = selectedListing?.listing ?? defaultValues;
    const taskTypes = ['chgTerm', 'chgSold', 'chgDetails', 'chgMajor', 'chgDel', 'chgPending', 'chgLeased', 'chgPropType', 'chgWithdrawn', 'chgActive', 'chgExp'];
    const isTaskEdit = taskTypes.includes(listingType);
    if (isTaskEdit) {
      // Update empty values with default values.
      Object.entries(formData).map(([key, value]) => {
        if (value == null && (key in defaultValues)) {
          formData[key] = defaultValues[key];
        }
        return null;
      });
      // Add missing defaulted fields (TBD if this is required).
      Object.entries(defaultValues).map(([key, defaultValue]) => {
        if (!(key in formData)) {
          formData[key] = defaultValue;
        }
        return null;
      });
    }
    return formData;
  },
);

/*
 Select Agent's form data taking default values into account:
  * on Create : pre-populate the field with the default value;
  * on Edit : Agent data takes priority over default values, even if Agent has null data for the field.
*/
export const selectAgentFormData = createSelector(
  selectOperationType,
  selectDefinitionType,
  selectDefaultValues,
  selectAgentSelected,
  (operationType, definitionType, defaultValues, selectedAgent) => {
    if (definitionType !== 'agent') return null;
    if (operationType === 'edit' && !selectedAgent) return null;

    const formData = selectedAgent ?? defaultValues;
    return formData;
  },
);

/*
 Select Office's form data taking default values into account:
  * on Create : pre-populate the field with the default value;
  * on Edit : Office data takes priority over default values, even if Office has null data for the field.
*/
export const selectOfficeFormData = createSelector(
  selectOperationType,
  selectDefinitionType,
  selectDefaultValues,
  selectOfficeSelected,
  (operationType, definitionType, defaultValues, selectedOffice) => {
    if (definitionType !== 'office') return null;
    if (operationType === 'edit' && !selectedOffice) return null;

    const formData = selectedOffice ?? defaultValues;
    return formData;
  },
);
